<template>
    <v-btn
        variant="outlined"
        :class="{ 'selected': modelValue, rounded }"
    >
        <div
            v-if="colorValue"
            class="color-swatch"
            :style="{
                ...colorValue
            }"
        ></div>
    </v-btn>
</template>

<script lang="ts" setup>
    import type { CssStyleObject } from '~/types';

    const props = withDefaults(
        defineProps<{
            modelValue?: Nilish<boolean>;
            color: Nilish<string | string[]>;
            rounded?: boolean;
        }>(),
        {
            rounded: true
        }
    );

    const { processColor } = useColorSwatches();
    const colorValue = ref<Nullable<CssStyleObject>>(processColor(props.color) || null);

    const unWatchColorProp = watch(
        () => props.color,
        (newColor: string | string[] | unknown) => {
            const cssProp = processColor(newColor);

            if (cssProp) {
                colorValue.value = cssProp;
            }
        }
    );

    onBeforeUnmount(() => {
        unWatchColorProp();
    });
</script>

<style lang="scss"></style>
